import React from 'react';
import {
  Button,
} from "..";

export const Promotion = ({ promoImage, brandImage, promoDate, promoDescription, promoLabel, promoUrl = "#", overrideLabel=''}) => {
  return (
    <div className="promotion__container">
      <div className="promotion__image">
        <img src={promoImage} />
      </div>
      <div className="promotion__description">
        {brandImage && (
          <div className="promotion__branding"></div>
        )}
        <div className="promotion__description__time">
          {promoDate}
        </div>
        <div className="promotion__description__text">
          {promoDescription}
        </div>
        <div className="promotion__button">
          <a target="_blank" href={promoUrl}>
            <Button rounded label={overrideLabel ? overrideLabel : "Get Tickets"} bgColor="#EF5B24" labelHoverColor="#ffffff" />
          </a>
        </div>
      </div>
    </div>
  );
}